import gql from 'graphql-tag'

export const subscriptionKeyDelete = gql`
  mutation SubscriptionKeyDelete($input: SubscriptionKeyDeleteInput!) {
    subscriptionKeyDelete(input: $input) {
      success
    }
  }
`
